import { sum } from "lodash";
import { useSelector } from "react-redux";

import { REPORTS_NEW_FEATURE_CAMPAIGNS, REPORT_TYPE_KEYS, ReportType } from "constants/reports/report-type";
import { isNewCampaignForAgent } from "hooks/settings";
import { IAgentFlags, selectLoggedInAgent } from "store/entities/agents";

export default function useNewReportsFeaturesCount(): number {
  const agent = useSelector(selectLoggedInAgent);

  return sum(
    (Object.keys(REPORT_TYPE_KEYS) as ReportType[]).map((section: ReportType) => {
      const [flagName] = REPORT_TYPE_KEYS[section];
      const lastVisitedDate = agent.flags[flagName as keyof IAgentFlags] || agent.createdAt;
      const newCampaignFound = (REPORTS_NEW_FEATURE_CAMPAIGNS[section] || []).find(campaign =>
        isNewCampaignForAgent(agent.createdAt, lastVisitedDate as string | Date, campaign)
      );
      if (newCampaignFound) {
        return 1;
      }
      return 0;
    })
  );
}
